import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'
import { RichText, Link, Image } from '@sitecore-jss/sitecore-jss-react';  
import Slider from "react-slick";

import '../../assets/css/0020_objects/0760_obj_a_gagner_formation.css'
import '../../assets/css/0020_objects/0710_obj_carousel_formation.css';
import '../../assets/css/0020_objects/0650_obj_favorite_formation_aside.css'

class ObjAGagnerHomeFormation extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

    componentDidMount() {
        this.setState({AGagnerItems: this.props.scDatasPushs});
    }

	onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

	render() {
		const sliderRef = slider => {this.slider = slider}
		const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: false,
			infinite: false,
			slidesToShow: 1,
			swipeToSlide: true,
			onSwipe: this.onSwipe.bind(this),
            dots: false,
            dotsClass:  "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: true,
            speed: 750,
			responsive: [
                {
                    breakpoint: 768,
                    settings: {
						dots: true,
						arrows: false
                    }
                }
            ]
        }

		return (<> {this.state.AGagnerItems && <>
			<div className="obj_a_gagner_formation">
				<div className="ctn_title">
					<h3 className="t_title"><strong>&Agrave; gagner</strong></h3>
					<p className="t_desc">en ce moment</p>
				</div>

				<div className="ctn_carrousel">
					<Slider {...settings} ref={sliderRef}>
						{ this.state.AGagnerItems.map((AGagnerItemsItem, index) => (
							<div className="item" key={index}>
								
								<div className="item_a_gagner_formation">
									<div className="ctn_media">
										<div className="obj_image">
											<picture className="ctn_image fade-in">
                                                <Image field={AGagnerItemsItem.visuel.jss}></Image>
											</picture>
										</div>
									</div>
									<div className="ctn_text">
                                        <RichText field={AGagnerItemsItem.title.jss} tag="h3"/>
										<div className="ctn_cta">
											<Link className="obj_cta reverse" field={AGagnerItemsItem.link.jss}>{AGagnerItemsItem.cta.value}</Link>
										</div>
									</div>
									{/* {AGagnerItemsItem.label} */}
								</div>

							</div>
						))}
					</Slider>
				</div>
			</div>
        </>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjAGagnerHomeFormation));